import styled from "@emotion/styled";
import { Chip } from "@mui/material";
import { COLOR_MAP } from "../../constants/ColorNames";
import { Tooltip } from "react-tooltip";
import InfoIconRed from "../../constants/icons/InfoIconRed";

type PillProps = {
  data: string;
  tagType: string;
  pausedBy?: string;
};

type CustomTagProps = {
  className?: string;
};

const CustomTag = styled(Chip)<CustomTagProps>((props) => ({
  border: 'none',
  borderRadius: "0.4rem",
  fontWeight: 400,
  fontSize: "10px",
  height: "18px",
  width: "auto",
  ".MuiChip-label": {
    padding: "2px 4px",
  },

  "&.draft": {
    color: "#B41480",
    backgroundColor: "#FCE8F6",
  },

  "&.live": {
    color: "#228568",
    backgroundColor: "#EAF6F3",
    width:"34px",

    "&::after": {
      content: '""',
      position: "absolute",
      right: "3px",
      top: "4px",
      height: "4px",
      width: "4px",
      backgroundColor: "red",
      borderRadius: "50%",
      border: "1px solid #fff"
    },
  },

  "&.finished": {
    color: "#228568",
    backgroundColor: "#EAF6F3",
  },

  "&.completed": {
    color: "#228568",
    backgroundColor: "#EAF6F3",
  },

  "&.whatsApp": {
    backgroundColor: COLOR_MAP.LIGHT_PURPLE,
    fontWeight: 600,
    color: COLOR_MAP.DARK_PURPLE,
  },

  "&.scheduled": {
    color: "#006899",
    backgroundColor: "#F0FAFF",
  },

  "&.paused": {
    color: "#E03923",
    backgroundColor: "#FCEBE9",
  },

  "&.auto_paused": {
    color: "#E03923",
    backgroundColor: "#FCEBE9",
  },

  "&.aborted": {
    color: "#E03923",
    backgroundColor: "#FCEBE9",
  },
  "&.rejected": {
    color: "#59566c",
    backgroundColor: "#e8e8eb",
  },

  " &.inreview": {
    color: "#8f5800",
    backgroundColor: "#ffedd1",
  },

  "&.in_review": {
    color: "#8f5800",
    backgroundColor: "#ffedd1",
  },
}));

const STATUS_COLORS = {
  draft: "#B41480",
  live: "#228568",
  finished: "#228568",
  completed: "#228568",
  whatsApp: COLOR_MAP.DARK_PURPLE,
  scheduled: "#006899",
  paused: "#E03923",
  auto_paused: "#E03923",
  aborted: "#E03923",
  rejected: "#59566c",
  inreview: "#8f5800",
  in_review: "#8f5800",
};

const ParentContainer = styled.div`
  position: relative;
  display: inline-grid;
`;

const Tag = (props: PillProps) => {
  const { data, tagType, pausedBy } = props;

  return (
    <ParentContainer>
      <CustomTag
        className={
          data?.split("-")?.[0]?.toLowerCase() || tagType?.toLowerCase()
        }
        label={
          <div style={{ display: "flex", alignItems: "center", gap: "2px", fontSize: '10px', lineHeight:"14px" }}>
            {data}
            {!!pausedBy && (
              <>
                <div
                  data-tooltip-id="c-status-tooltip"
                  data-tooltip-content={pausedBy}
                  style={{ display: "inline-flex" }}
                >
                  <InfoIconRed fill={(STATUS_COLORS as any)[data?.split("-")?.[0]?.toLowerCase() || tagType?.toLowerCase()] || ""} />
                </div>
                <Tooltip
                  id="c-status-tooltip"
                  style={{
                    backgroundColor: "#1d1934",
                    color: "white",
                    padding: "4px 8px",
                    fontSize: "12px",
                    zIndex: 10000,
                    opacity: 1,
                    maxWidth: '300px',
                    textAlign: 'left',
                    whiteSpace: 'normal',
                  }}
                />
              </>
            )}
          </div>
        }
      />
    </ParentContainer>
  );
};

export default Tag;
